import { Loader2, Volume2 } from "lucide-react";

/**
 * Read-only transcript view for Conversation Mode.
 * Receives `turns` (array) and an `onReplay(turn)` callback.
 */
export default function ConversationTranscript({ turns, transcriptRef, onReplay }) {
  return (
    <div
      ref={transcriptRef}
      className="p-4 max-h-[420px] min-h-[160px] overflow-y-auto space-y-3"
      data-testid="conv-transcript"
    >
      {turns.length === 0 ? (
        <p className="text-zinc-400 text-sm text-center py-8" data-testid="conv-transcript-empty">
          Tap a mic above. Each turn is transcribed, translated, and spoken aloud for the other side.
        </p>
      ) : (
        turns.map((t) => {
          const isTherapist = t.speaker === "therapist";
          return (
            <div
              key={t.id}
              className={`flex ${isTherapist ? "justify-end" : "justify-start"}`}
              data-testid={`conv-turn-${t.id}`}
            >
              <div
                className={`max-w-[78%] rounded-2xl px-4 py-3 ${
                  isTherapist ? "bg-zinc-900 text-white rounded-br-md" : "bg-zinc-100 text-zinc-900 rounded-bl-md"
                }`}
              >
                <p className={`text-[10px] uppercase tracking-[0.2em] mb-1 ${isTherapist ? "text-zinc-400" : "text-zinc-500"}`}>
                  {isTherapist ? "You" : "Patient"} · {t.fromLang}
                </p>
                <p className="text-sm leading-relaxed">{t.original}</p>
                <div className={`mt-2 pt-2 border-t flex items-start gap-2 ${isTherapist ? "border-white/10" : "border-zinc-200"}`}>
                  <p className={`text-[10px] uppercase tracking-[0.2em] mt-0.5 shrink-0 ${isTherapist ? "text-zinc-400" : "text-zinc-500"}`}>
                    {t.toLang}
                  </p>
                  <p className={`text-base font-medium leading-snug flex-1 ${isTherapist ? "" : "text-zinc-900"}`}>
                    {t.translating ? (
                      <span className={`inline-flex items-center gap-2 italic opacity-70 ${isTherapist ? "text-zinc-300" : "text-zinc-500"}`}>
                        <Loader2 className="w-3 h-3 animate-spin" /> translating…
                      </span>
                    ) : (
                      t.translation
                    )}
                  </p>
                  <button
                    onClick={() => t.translation && onReplay?.(t)}
                    disabled={t.translating || !t.translation}
                    className={`p-1 rounded transition-colors ${isTherapist ? "text-zinc-400 hover:text-white disabled:opacity-40" : "text-zinc-400 hover:text-zinc-900 disabled:opacity-40"}`}
                    title="Replay"
                    data-testid={`conv-replay-${t.id}`}
                  >
                    <Volume2 className="w-3.5 h-3.5" />
                  </button>
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
